export type DataAttributeKey = `data-${string}`
type VariableKey = `--${string}`
declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    [dataAttribute: DataAttributeKey]: unknown | undefined
  }
  interface CSSProperties {
    [variable: VariableKey]: unknown | undefined
  }
}

declare module 'next/link' {
  interface Props {
    [dataAttribute: DataAttributeKey]: unknown | undefined
  }
}

export type AboutUs = {
  hero_section: {
    title: string
    content: string
    images: { image: string }[]
  }
  our_vision: {
    icon: string
    title: string
    content: string
  }
  our_mission: {
    icon: string
    title: string
    content: string
  }
  quotation: {
    content: string
    avatar: string
    name: string
    title: string
  }
  our_values: {
    image: string
    title: string
    values: {
      title: string
      content: string
    }[]
  }
  our_services: {
    title: string
    services: {
      icon: string
      title: string
      content: string
      cta: string
      cta_url: string
    }[]
  }
  our_expert: {
    title: string
    content: string
    cta: string
    cta_url: string
    experts: {
      ID: string
      display_name: string
      specialty: string
      profile_url: string
      avatar: string
      avatar_thumbnail: string
    }[]
  }
  quality_control: {
    title: string
    content: string
    quality_card: { image: string; title: string; content: string }[]
  }

  policy: {
    title: string
    sections: {
      title: string
      content: string
      cta: string
      cta_url: string
    }[]
  }
  our_team: {
    title: string
    content: string
    members: {
      avatar: string
      name: string
      title: string
      description: string
      linkedin: string
    }[]
  }
  recruitment: {
    background: string
    title: string
    icon: string
    cta: string
    cta_url: string
  }
  about: {
    title: string
    content: string
    cta: string
    cta_url: string
  }
  contact: {
    title: string
    content: string
    info: { title: string; info: string }[]
  }
}

export type DesktopMenuPopup =
  | 'categories'
  | 'tools'
  | 'profile'
  | 'together'
  | 'language'
  | 'none'

export type MobileMenuPopup = 'categories' | 'profile' | 'language' | 'none'

export type LogoType =
  | 'hellobacsi'
  | 'hellosehat'
  | 'hellohealth'
  | 'hellotogether'
  | 'hellocare'
  | 'logomark'
  | 'hellodoctor'
  | 'hellokrupet'
  | 'helloswasthya'
  | 'hellokhunmor'
  | 'hellodoktor'
  | 'hellosayarwon'
  | 'helloyishi'
  | 'hellojiankang'

export type CategoriesLayout = 'short' | 'long'

export type WelcomeFeatureApi = {
  name: string
  description: string
  icon: string
}

export type UrlSource =
  | 'first_login'
  | 'welcome_back'
  | 'comment'
  | 'feature'
  | 'my-health'

export type FooterInfo = {
  general: {
    logo: string
    content: string
    copyright: string
    verified: Array<{ image: string; url: string }>
  }
  menu: Array<{
    menu_title: string
    items: Array<{ title: string; url: string }>
  }>
  social: {
    title: string
    socials: Array<{ icon: string; name: string; url: string }>
  }
  branch: {
    title: string
    branch: Array<{ flag: string; name: string; url: string }>
  }
}

export type RedirectSourceType =
  | 'bmi'
  | 'bmr'
  | 'due-date'
  | 'ovulation'
  | 'comment'
  | 'communities'
  | 'pregnancy-weight-gain'
  | 'target-heart-rate'
  | 'reaction'
  | 'vaccination-tool'
  | 'workshop-register'
  | 'baby-growth'
  | 'baby-vaccine'
  | 'baby-poop-checking'
  | ''

export type CareLocalisedSlugsType =
  | 'HOSPITAL'
  | 'SERVICE'
  | 'DOCTOR'
  | 'ALL'
  | 'SEARCH'
  | 'SPECIALTIES'
  | 'VACCINATIONS'
  | 'CURRENT'

export type RecordChartType = 'day' | 'month' | 'year'

export type RecordChartByMonthOption = '3-month' | '6-month' | '12-month'
export type RecordChartByYearOption = '1-year' | '2-year' | '3-year'
export type LatLngType = {
  lat: number
  lng: number
}

export * from './Ads'
export * from './Affiliate'
export * from './Article'
export * from './Author'
export * from './BabyGrowth'
export * from './Banner'
export * from './BMI'
export * from './Breadcrumb'
export * from './Calendar'
export * from './Care'
export * from './Carousel'
export * from './Category'
export * from './common'
export * from './Community'
export * from './DataTracking'
export * from './Expert'
export * from './FAQ'
export * from './HealthTool'
export * from './Keyword'
export * from './Leadgen'
export * from './Locale'
export * from './LocalStored'
export * from './MetaTag'
export * from './Post'
export * from './QuickBooking'
export * from './Reviewed'
export * from './Sponsor'
export * from './Spotlight'
export * from './StaticPage'
export * from './Subot'
export * from './User'
export * from './WeekOfPregnancy'
export * from './CarePath'
export * from './ThirdParty'
export * from './UnifiedProfile'
